import { createHead } from "@unhead/vue";
import { createPinia } from "pinia";
import { createApp } from "vue";
import * as Sentry from "@sentry/vue";
import App from "./App.vue";
import router from "./router";
import "./assets/styles/index.css";

const SENTRY_DSN =
  "https://f85921c36bf8c7e21f4c1153c43e54e6@o504398.ingest.us.sentry.io/4508880406708224";

const app = createApp(App);

Sentry.init({
  app,
  environment: import.meta.env.MODE,
  dsn: SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracesSampleRate: 1.0,
});

app.use(createPinia());
app.use(createHead());
app.use(router);

app.mount("#app");
